import { render, staticRenderFns } from "./SuggestPart.vue?vue&type=template&id=230b8614"
import script from "./SuggestPart.ts?vue&type=script&lang=ts&external"
export * from "./SuggestPart.ts?vue&type=script&lang=ts&external"
import style0 from "./SuggestPart.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports